import {
    DATE_FORMAT_CATEGORIES,
    DAY_FORMATS,
    IDateFormat,
    IDateLocalizer,
    MONTH_FORMATS,
    YEAR_FORMATS,
} from '../../DatePresenter';

const MONTH_SHORT_NAMES: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

/**
 * Localizes a date into an en-US standard format for consumption by an end user.
 */
export class EnUsShortDateLocalizer implements IDateLocalizer {
    /**
     * Gets the localized day
     * @param day The day to be localized, this is the day of the month starting at 1.
     * @param format The format the day should be localized into
     */
    public getDay (day: number, format: DAY_FORMATS): string {
        if (format === DAY_FORMATS.NUMBER) {
            return day.toString();
        }

        throw new Error('Unsupported format for localized day');
    }

    /**
     * Gets the localized month
     * @param month The month to be localized, this is a number between 0 (January) and 11 (December).
     * @param format The format the month should be localized into
     */
    public getMonth (month: number, format: MONTH_FORMATS): string {
        if (format !== MONTH_FORMATS.SHORT) {
            throw new Error('Unsupported format for localized month');
        }

        return MONTH_SHORT_NAMES[month];
    }

    /**
     * Gets the localized year
     * @param year The year to be localized
     * @param format The format the year should be localized into
     */
    public getYear (year: number, format: YEAR_FORMATS): string {
        if (format === YEAR_FORMATS.NUMBER) {
            return year.toString();
        }

        throw new Error('Unsupported format for localized year');
    }

    /**
     * Gets the appropriate format for a date to be in. For en-US this is MMM d, yyyy.
     */
    public getDateFormat (): IDateFormat {
        return [
            {
                category: DATE_FORMAT_CATEGORIES.MONTH,
                format: MONTH_FORMATS.SHORT,
            },
            ' ',
            {
                category: DATE_FORMAT_CATEGORIES.DAY,
                format: DAY_FORMATS.NUMBER,
            },
            ', ',
            {
                category: DATE_FORMAT_CATEGORIES.YEAR,
                format: YEAR_FORMATS.NUMBER,
            },
        ];
    }
}
